import { useRef } from 'react';
import stylex from '@stylexjs/stylex';
import { useIntersectionObserver } from 'usehooks-ts';

import type { IContainerProps } from '~/components/utils/Container';

export type IActionBarProps = IContainerProps & {
  children: React.ReactNode;
  alwaysVisible?: boolean;
};

const styles = stylex.create({
  actionBar: {
    zIndex: 99,
  },
  actionBar$fixed: (width?: number) => ({
    position: 'fixed',
    bottom: 0,
    width: width ?? 'auto',
  }),
});

export const ActionBar: React.FC<IActionBarProps> = (props) => {
  const { sx, children, alwaysVisible } = props;

  const hostRef = useRef<HTMLDivElement>(null);
  const {
    isIntersecting: isActionBarVisible,
    ref: intersectingTestedElementRef,
  } = useIntersectionObserver({
    threshold: 1,
    initialIsIntersecting: true,
  });

  return (
    <div {...stylex.props(styles.actionBar, sx)} ref={hostRef}>
      {children}

      <div ref={intersectingTestedElementRef} />
      {!isActionBarVisible && alwaysVisible ? (
        <div
          // TODO: ideally, we should listen to the ref's width changes.
          {...stylex.props(
            styles.actionBar,
            styles.actionBar$fixed(hostRef.current?.clientWidth),
          )}
        >
          {children}
        </div>
      ) : null}
    </div>
  );
};
